import FooterLeft from './FooterLeft'

export default FooterLeft
